export const getEliteScoresQueryKey = (fundCategory: string, isin: string) => {
  return ['eliteScores', fundCategory, isin]
}
